<template>
  <v-alert
    v-if="message"
    type="warning"
    variant="tonal"
    icon="mdi-alert-circle-outline"
    class="maintenance-banner"
  >
    <span v-html="message" />
  </v-alert>
</template>

<script>
import config from "../config";

const LOCALE_TAGS = {
  en: "en-GB",
  it: "it-IT",
  sq: "sq-AL",
  de: "de-DE",
  fr: "fr-FR",
  es: "es-ES",
};

export const PLACEHOLDERS = { date: "{date}", start: "{start}", end: "{end}" };

export function escapeHtml(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function formatMaintenanceDate(isoDate, locale) {
  if (!isoDate || String(isoDate).indexOf("-") === -1) return "";
  const [year, month, day] = isoDate.split("-").map(Number);
  if (!year || !month || !day) return "";
  return new Intl.DateTimeFormat(LOCALE_TAGS[locale] || "en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(year, month - 1, day)));
}

export function formatMaintenanceMessage(notice, locale, t) {
  if (!notice || !notice.date) return "";
  const date = formatMaintenanceDate(notice.date, locale);

  const custom = notice.customMessages && notice.customMessages[locale];
  const text = custom
    ? escapeHtml(custom)
    : escapeHtml(t("maintenance_notice.banner_text", PLACEHOLDERS));
  return text
    .replace("{date}", `<b>${escapeHtml(date)}</b>`)
    .replace("{start}", `<b>${escapeHtml(notice.startTime)}</b>`)
    .replace("{end}", `<b>${escapeHtml(notice.endTime)}</b>`);
}

export default {
  name: "MaintenanceBanner",
  data() {
    return { notice: null };
  },
  computed: {
    message() {
      if (!this.notice || !this.notice.enabled) return "";
      return formatMaintenanceMessage(
        this.notice,
        this.$i18n.locale,
        (key, named) => this.$t(key, named),
      );
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      try {
        const res = await this.axios.get(
          `${config.getServerUri()}/maintenance-notice`,
        );
        this.notice = res.data;
      } catch (err) {
        this.notice = null;
      }
    },
  },
};
</script>

<style scoped>
.maintenance-banner {
  line-height: 1.5;
}
</style>
